<script lang="ts">
	import queryString from "query-string";
	import logo from "../assets/img/Logo.png";
	import AppLayout from "../layouts/AppLayout.svelte";
	import Form from "../layouts/Form.svelte";
	import NewResultLayout from "../layouts/NewResultLayout.svelte";
	import {
		DefaultTextInput,
		DefaultButton,
		InputFrame,
		DefaultDone,
	} from "@hitit/new_ui";
	import { newApiClient, newAuthClient } from "@hitit/api";
	import { t } from "@hitit/hub/src/stores";

	let secureToken = queryString.parse(location.search)["token"] as string;
	let success: boolean = false;
	let username: string = "";
	let password: string = "";
	let loading = false;
	let errorMessage = "";

	if (!secureToken) {
		location.assign("/");
	}

	$: buttonDisabled = username === "" || password === "";

	async function handleSubmit(e: Event) {
		try {
			e.preventDefault();
			loading = true;
			const noop = () => {};
			let token = "";
			let auth = newAuthClient(
				"",
				"",
				"",
				"",
				(v) => (token = v),
				noop,
				noop,
				noop
			);

			try {
				await auth.bypassLogin(username, password);
			} catch {
				throw new Error($t("sso.error.loginError"));
			}

			let api = newApiClient(
				() => Promise.resolve(token),
				() => Promise.resolve()
			);

			try {
				await api.verifyEmail(secureToken);
				success = true;
			} catch {
				throw new Error($t("sso.error.unknownError"));
			}
		} catch (e) {
			const _e = e as Error;
			errorMessage = _e.message;
		} finally {
			loading = false;
		}
	}
</script>

<AppLayout useTerm={!success}>
	{#if success}
		<NewResultLayout text={username}>
			<div class="done-box" slot="result-icon" id="success-icon">
				<DefaultDone />
			</div>
			<p class="result">{$t("sso.verifyEmail.success_verify_email")}</p>
			<empty />
			<div class="result-button">
				<DefaultButton on:click={() => location.assign("/")}>
					<span class="white">{$t("sso.signup.go_to_login")}</span>
				</DefaultButton>
			</div>
		</NewResultLayout>
	{:else}
		<img src={logo} alt="logo" on:click={() => location.assign("/")} />
		<div class="description">
			<span>{$t("sso.verifyEmail.verify_email")}</span>
			<p>{$t("sso.verifyEmail.why_we_need_login")}</p>
		</div>
		<Form on:submit={handleSubmit} useLogo={false} clearMode={true}>
			<InputFrame direction={"column"}>
				<DefaultTextInput
					bind:value={username}
					clearButtonDisplay={username !== ""}
					clearCallback={() => (username = "")}
					placeholder={$t("sso.username")}
				/>
				<DefaultTextInput
					password
					bind:value={password}
					clearButtonDisplay={password !== ""}
					clearCallback={() => (password = "")}
					placeholder={$t("sso.password")}
				/>
			</InputFrame>
			<p class="error">{errorMessage}</p>
			<DefaultButton
				isLoading={loading}
				defaultClassname={"sso-verifyEmailButton"}
				disabled={buttonDisabled || loading}
			>
				<span class="white"> LOGIN </span>
			</DefaultButton>
		</Form>
	{/if}
</AppLayout>

<style lang="scss">
	@import "../variables.scss";
	img {
		width: 148px;
		height: 67px;
		margin-bottom: 60px;

		&:hover {
			cursor: pointer;
		}
	}
	.result-button {
		width: 100%;
		max-width: 400px;
	}

	.description {
		display: flex;
		flex-direction: column;
		gap: 10px;

		width: 100%;
		max-width: 400px;
		box-sizing: border-box;
		padding: 0px 30px;
		span {
			color: white;
			font-weight: 500;
			font-size: 1.25rem;
		}
		p {
			color: var(--default-disabled-btn-1);
			font-size: 1.125rem;
			line-height: 20px;
		}
	}

	.error {
		box-sizing: border-box;
		height: 57px;
		color: var(--error-color-1);
		padding: 8px 10px;
	}
	span.white {
		color: white;
		font-weight: 500;
	}

	:global(button.sso-verifyEmailButton:disabled) {
		background-color: #a5c1f9;
	}
	.done-box {
		width: 121px;
		height: 115.2px;
	}

	p.result {
		color: white;
		font-size: 1.125rem;
		margin-top: 20px;
	}

	empty {
		display: block;
		height: 70px;
	}
	@include DesktopSize {
		.description {
			padding: 0;
		}
	}
</style>
